import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LOGIN_STATUS, SCREEN_TYPE } from '../../utils/Constants.tsx';
import { removeAllItemsFromLocalStorage } from "../../utils/Util.tsx";

interface State {
  isLoading: boolean;
  error?: string;
  status: string;
  token: string;
  screenType: string;
  refreshTime: number;
}

const initialState : State = {
  status: LOGIN_STATUS.NO_AUTHENTICATED,
  token: '',
  isLoading: false,
  screenType: SCREEN_TYPE.NORMAL,
  refreshTime: 20000 // 20 seconds
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    handleAuthentication: (state, action) => {
      state.status = action.payload.authStatus;
      state.token = action.payload.token;
      localStorage.setItem('AUTH_TOKEN', state.token);
      localStorage.setItem('AUTH_STATUS', state.status);
    },
    checkAuthentication: (state) => {
      const token = state.token
      state.status = token ? LOGIN_STATUS.AUTHENTICATED : LOGIN_STATUS.NO_AUTHENTICATED;
    },
    startLoading(state: State) {
      state.isLoading = true;
    },
    stopLoading(state: State) {
      state.isLoading = false;
    },
    hasError(state: State, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
      state.token = '';
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
    },
    logout(state: State) {
      state.status = LOGIN_STATUS.NO_AUTHENTICATED;
      state.token = '';
      removeAllItemsFromLocalStorage();
    },
    updateScreen(state: State, action) {
      state.screenType = action.payload;
    },
    updateRefreshTime(state: State, action){
      state.refreshTime = Number(action.payload || 20) * 1000; // 20 seconds default
    }
  },
});

export const {
  startLoading,
  stopLoading,
  hasError,
  handleAuthentication,
  checkAuthentication,
  logout,
  updateScreen,
  updateRefreshTime
} = loginSlice.actions;

export default loginSlice.reducer;
